/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ChevronDown/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ChevronDown({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ChevronDown",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#52606D"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ChevronDown.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-Z1itfpV': alignSelf,'--mt-2-Z1itfpV': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1itfpV': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1itfpV': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1itfpV': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1itfpV': opacity,'--w-10-Z1itfpV': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1itfpV': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1itfpV': fill,'--a-7-Z1itfpV': isAnimated ? animation : "none",'--sd-8-Z1itfpV': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1itfpV': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2ChevronDown.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_1686_58430)"
 className="views-block"
>
<path
  data-testid="Tysiav2ChevronDown.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.226 4.226c-.301.3-.301.788 0 1.088l4.347 4.348c.45.45 1.182.45 1.633 0l4.348-4.348a.77.77 0 00-1.09-1.088L6.39 8.3 2.314 4.226a.77.77 0 00-1.088 0z"
 style={{'--f-12-Z1itfpV': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}